import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Avatar,
  Chip,
  Tooltip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  IconButton,
} from "@mui/material";
import LogoIcon from "../../../assets/images/logo-icon.png";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import variables from "../../../assets/styles/variables.module.scss";
import TypingIndicator from "../../../Shared-ui/SharedComponents/TypingIndicator";
import LineMdAccount from "../../../assets/icons/LineMdAccount";
import { Params, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  StartLoading,
  StopLoading,
} from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { Agent, AgentTheme } from "../../../Shared-ui/Types/Agent";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { AGENT, AGENT_SHORTCUT, CHAT_HISTORY, CHAT_HISTORY_DETAIL, TEAMS } from "../../../Services/Endpoint";
import { ShowError } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import PlayGroundInitialMessage from "../../Components/PlayGroundIntialMessage";
import { Message, UserMessage } from "../../../Shared-ui/Types/PlayGround";
import { v4 as uuidv4 } from "uuid";
import { PlayGroundEnum } from "../../../Shared-ui/Enum/PlayGroundEnum";
import { GetSession } from "../../../Shared-ui/utils/Auth/AuthHelpers";
import { MultiAgent } from "../../../Shared-ui/Types/MultiAgent";
import { marked } from "marked";
import AgentPlayGroundTools from "../../Components/AgentPlayGroundTools";
import AgentPlaygroundReferences from "../../Components/AgentPlaygroundReferences";
import AgentQuestions from "../../Components/AgentQuestions";
import CachedIcon from "@mui/icons-material/Cached";
import AgentPrompts from "../../Components/AgentPromts";
import { capitalizeFirstLetter } from "../../../Shared-ui/utils/Common/Common";
import striptags from "striptags";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import NewChatIcon from "@mui/icons-material/Add";
import RecentChatIcon from "@mui/icons-material/History";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RecentChatsByUser from "../../Components/RecentsChatsByUser";
import EndChatIcon from "../../../assets/icons/EndChatIcon";


const IFrameMultiAgent: React.FC = () => {
  const { teamsId, apiKey } = useParams<Params>();

  const dispatch = useDispatch();
  const uniqueId = uuidv4();
  const [intialMessage, setIntialMessage] = useState<string>("");
  const [agents, setAgents] = useState<MultiAgent>();
  const [userInput, setUserInput] = useState<string>("");
  const [botTyping, setBotTyping] = useState<boolean>(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [messages, setMessages] = useState<Message[]>([]);
  const endOfMessagesRef = useRef<HTMLDivElement>(null);
  const [conversationId, setConversationId] = useState<string>("");
  const [showQuestions, setShowQuestions] = useState<boolean>(true);
  const [showInitialMessage, setShowInitialMessage] = useState(true);
  const [incomingTextColor, setIncomingTextColor] = useState("#000000");
  const [agentShortcuts, setAgentShortcuts] = useState<any>([]);
  const [showCitations, setShowCitations] = useState<boolean>(false);
  const [pageContext, setPageContext] = useState<{
    html: string;
    url: string;
    title: string;
  } | null>(null);
  const [userContext, setUserContext] = useState<any>(null);
  const [userId, setUserId] = useState<string | null>("");
  const [guestUserId, setGuestUserId] = useState<string | null>("");
  const [chatHistoryId, setChatHistoryId] = useState<string>("");
  console.log(chatHistoryId, "chatHistoryId multi agent");

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [showHistory, setShowHistory] = useState<boolean>(false);
  const [chatHistories, setChatHistories] = useState<any[]>([]);
  console.log(chatHistories, "chatHistories multi agent");

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [pageSize] = useState<number>(10);
  const isCancelledStream = useRef<boolean>(true);

  const [agentTheme, setAgentTheme] = useState<AgentTheme>({
    backgroundColor: "#ffffff",
    titleColor: "#000000",
    outgoingChatTextColor: "#000000",
    incomingChatTextColor: "#000000",
    chatBubbleButtonColor: variables.primaryColor,
    mode: "single",
    angle: 180
  });
  const responseId = useRef<string>("");


  // Debug: Log when pageContext changes
  useEffect(() => {
    if (pageContext) {
      console.log('📄 Page context updated in iframe:', {
        title: pageContext.title,
        url: pageContext.url,
        htmlLength: pageContext.html.length
      });
    } else {
      console.log('📄 Page context is null in iframe');
    }
  }, [pageContext]);

  // Debug: Log when userContext changes
  useEffect(() => {
    if (userContext) {
      console.log('👤 User context updated in iframe:', userContext);
      setUserId(userContext.id);
      console.log(userId, "userId loaded");
    } else {
      console.log('👤 User context is null in iframe');
    }
  }, [userContext]);

  useEffect(() => {
    const scrollBehavior = botTyping ? "auto" : "smooth";
    endOfMessagesRef.current?.scrollIntoView({ behavior: scrollBehavior });
  }, [messages.length, botTyping]);

  useEffect(() => {
    getAgent();
    getAgentShortCut()
  }, [teamsId]);

  useEffect(() => {
    if (!botTyping) {
      inputRef.current?.focus();
    }
  }, [messages, botTyping]);

  // Listen for post messages from parent window
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      console.log('🔄 Iframe received message:', event.data);

      // Verify the message is from the expected origin (parent window)
      // Allow null origin for local file system and localhost origins
      if (event.origin !== window.location.origin &&
        event.origin !== 'null' &&
        !event.origin.includes('localhost') &&
        event.origin !== '') {
        console.log('⚠️ Message origin not trusted:', event.origin);
        return;
      }

      if (event.data.type === 'PAGE_CONTENT') {
        console.log('✅ Received page content from parent:', {
          html: event.data.html,
          url: event.data.url,
          title: event.data.title
        });

        // Store the page content in state for use in chat
        const newPageContext = {
          html: event.data.html,
          url: event.data.url,
          title: event.data.title
        };

        console.log('📄 Setting pageContext to:', newPageContext);
        setPageContext(newPageContext);

        // Show visual feedback that page context was updated
        if (pageContext && pageContext.url !== newPageContext.url) {
          console.log('🔄 Page context updated - user navigated to new page');
          // You could add a toast notification here if desired
        }

        // Send confirmation back to parent window
        if (window.parent && window.parent !== window) {
          window.parent.postMessage({
            type: 'PAGE_CONTENT_RECEIVED',
            message: 'Page content successfully received by multi-agent iframe',
            data: {
              html: event.data.html,
              url: event.data.url,
              title: event.data.title
            }
          }, '*');
          console.log('✅ Confirmation sent back to parent');
        }
      } else if (event.data.type === 'USER_DATA') {
        console.log('✅ Received user data from parent:', event.data.data);

        // Store the user data in state for use in chat
        setUserContext(event.data.data);
        console.log('📊 User data received in multi-agent iframe:', event.data.data);

        // Send confirmation back to parent window
        if (window.parent && window.parent !== window) {
          window.parent.postMessage({
            type: 'USER_DATA_RECEIVED',
            message: 'User data successfully received by multi-agent iframe',
            data: event.data.data
          }, '*');
          console.log('✅ User data confirmation sent back to parent');
        }
      } else if (event.data.type === 'REQUEST_GUEST_USER_DATA') {
        console.log('👤 Received request for guest user data generation in multi-agent iframe');

        // Generate guest user data
        const guestUserId = crypto.randomUUID();
        const guestUserData = {
          id: guestUserId,
          name: 'Guest User',
          email: `${guestUserId}@dummy.zeaiq.com`,
          type: 'guest',
          timestamp: new Date().toISOString()
        };

        console.log('👤 Generated guest user data:', guestUserData);

        // Set the local state so API requests will include user context
        setUserContext(guestUserData);
        setUserId(guestUserId);

        // Send the generated guest user data back to parent window
        if (window.parent && window.parent !== window) {
          window.parent.postMessage({
            type: 'GUEST_USER_DATA_GENERATED',
            message: 'Guest user data successfully generated by multi-agent iframe',
            data: guestUserData
          }, '*');
          console.log('✅ Guest user data sent back to parent');
        }
      } else if (event.data.type === 'CHAT_HISTORY_ID') {
        console.log('📚 Received chat history ID from parent:', event.data.data);

        // Set the chat history ID from parent window
        const { agentId, userId, chatHistoryId } = event.data.data;
        if (agentId && userId && chatHistoryId) {
          setChatHistoryId(chatHistoryId);
          console.log('📚 Set chat history ID from parent:', chatHistoryId);
        }
      } else {
        console.log('ℹ️ Received message with type:', event.data.type);
      }
    };

    console.log('🔄 Setting up message listener in iframe');
    window.addEventListener('message', handleMessage);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  const getAgent = async () => {
    try {
      dispatch(StartLoading());
      const response = await fetch(`${TEAMS}/${teamsId}`, {
        method: "GET",
        headers: {
          "x-api-key": `${apiKey}`,
          "Content-Type": "application/json",
          Accept: "text/event-stream",
        },
        mode: "cors",
        credentials: "same-origin",
      });
      const data = await response.json();
      setIntialMessage(`Hello! How can I assist you today?`);
      setAgents(data);
      setAgentTheme(data.team_metadata?.agent_theme || agentTheme);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  };

  const getAgentShortCut = async () => {
    try {
      dispatch(StartLoading());
      const response = await fetch(`${AGENT_SHORTCUT}`, {
        method: "GET",
        headers: {
          "x-api-key": `${apiKey}`,
          "Content-Type": "application/json",
          Accept: "text/event-stream",
        },
        mode: "cors",
        credentials: "same-origin",
      });
      const data = await response.json();
      // const data = await BaseInstance.get(`${AGENT_SHORTCUT}`)

      setAgentShortcuts(data || []);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }
  };


  const sendMessageQuestions = async (question: string) => {
    isCancelledStream.current = false;
    setShowInitialMessage(false);
    setShowQuestions(false);

    // Check if userContext is available, if not, generate a guest user
    if (!userContext) {
      console.log('👤 No user context available, generating guest user for question');
      const guestUserId = crypto.randomUUID();
      const guestUserData = {
        id: guestUserId,
        name: 'Guest User',
        email: `${guestUserId}@dummy.zeaiq.com`,
        type: 'guest',
        timestamp: new Date().toISOString()
      };
      setUserContext(guestUserData);
      setUserId(guestUserId);

      // Notify parent window about guest user generation
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({
          type: 'GUEST_USER_GENERATED',
          message: 'Guest user generated for question',
          data: guestUserData
        }, '*');
      }
    }

    const data: UserMessage = {
      input: question,
      conversation_id: "",
    };

    // Debug: Show current userContext state
    console.log('👤 Current userContext before creating payload:', userContext);
    console.log('👤 Current userId before creating payload:', userId);

    // Create the request payload for the API
    const requestPayload = {
      input: question,
      conversation_id: "",
      chat_history_id: chatHistoryId || undefined,
      metadata: {
        ...(pageContext && { page_context: pageContext }),
        ...(userContext && { user_context: userContext })
      }
    };

    console.log('📤 Sending question with payload:', requestPayload);
    console.log('📄 Page context available:', !!pageContext);
    console.log('📄 Page context value:', pageContext);
    console.log('👤 User context available:', !!userContext);
    console.log('👤 User context value:', userContext);
    userContext?.id && console.log('👤 User ID:', userContext.id);

    console.log('📄 Request payload JSON:', JSON.stringify(requestPayload, null, 2));

    // Debug: Show final payload structure
    console.log('🔍 Final request payload structure:', {
      hasInput: !!requestPayload.input,
      hasConversationId: !!requestPayload.conversation_id,
      hasChatHistoryId: !!requestPayload.chat_history_id,
      hasMetadata: !!requestPayload.metadata,
      hasPageContext: !!requestPayload.metadata?.page_context,
      hasUserContext: !!requestPayload.metadata?.user_context,
      userContextId: requestPayload.metadata?.user_context?.id
    });

    // Add user message
    setMessages((prev) => [
      ...prev,
      { sender: PlayGroundEnum.USER, userData: data },
    ]);
    setUserInput("");
    setBotTyping(true);
    try {
      if (!agents?.team_metadata.streaming) {
        const response = await fetch(
          `${TEAMS}/${teamsId}/execute?stream=true`,
          {
            method: "POST",
            headers: {
              "x-api-key": `${apiKey}`,
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify(requestPayload),
            mode: "cors",
            credentials: "same-origin",
          }
        );

        if (!response.ok || !response.body) {
          throw new Error("Failed to stream");
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");

        // Add placeholder agent message
        setMessages((prev) => [...prev, { sender: PlayGroundEnum.AGENT, isMessageLike: null }]);

        let buffer = "";
        var content = "";
        const tool_calls: any[] = [];

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          if (isCancelledStream.current) break;

          buffer += decoder.decode(value, { stream: true });

          const lines = buffer.split("\n");
          for (const line of lines) {
            if (line.startsWith("data: ")) {
              const jsonPart = line.replace(/^data: /, "").trim();

              if (!jsonPart || jsonPart === "[DONE]") return;

              try {
                const parsed = JSON.parse(jsonPart);
                if (!parsed.is_complete) {
                  content += parsed.response;
                  const sanitizedContent = await marked.parse(content);
                  setConversationId(parsed.conversation_id);

                  setMessages((preVal) => {
                    let lastMsg = preVal[preVal.length - 1];
                    lastMsg = {
                      ...lastMsg,
                      agentData: { response: sanitizedContent, rawResponse: content, conversation_id: parsed.conversation_id },
                    };
                    console.log(lastMsg);
                    return [...preVal.slice(0, preVal.length - 1), lastMsg];
                  });
                } else {
                  if (parsed?.metadata?.agent_responses) {
                    const agent_responses = parsed?.metadata.agent_responses;
                    agent_responses?.forEach((agent_res: any) => {
                      if (agent_res.metadata?.tool_calls) {
                        tool_calls.push(...agent_res.metadata.tool_calls);
                      }
                    });
                    setMessages((preVal) => {
                      let lastMsg = preVal[preVal.length - 1];
                      lastMsg = {
                        ...lastMsg,
                        agentData: {
                          response: lastMsg.agentData?.response || "",
                          rawResponse: lastMsg.agentData?.rawResponse || content,
                          agent_responses: agent_responses,
                          metadata: { tool_calls: tool_calls },
                        },
                      };
                      // console.log(lastMsg)
                      return [...preVal.slice(0, preVal.length - 1), lastMsg];
                    });
                  }

                  // Extract chat history ID if present in the final chunk
                  if (parsed.chat_history_id) {
                    setChatHistoryId(parsed.chat_history_id);
                    console.log('📚 Received chat history ID from streaming team response:', parsed.chat_history_id);
                  }
                }
              } catch (e) {
                console.error("Parse error:", jsonPart, e);
              }
            }
          }

          // Keep partial buffer (in case a line is split across chunks)
          buffer = lines[lines.length - 1];
        }
      } else {
        const resData = await fetch(
          `${TEAMS}/${teamsId}/execute?stream=false`,
          {
            method: "POST",
            headers: {
              "x-api-key": `${apiKey}`,
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify(requestPayload),
            mode: "cors",
            credentials: "same-origin",
          }
        );

        if (!resData.ok) {
          throw new Error("Failed to response");
        }
        const responseData = await resData.json();
        setConversationId(responseData.conversation_id);

        // Extract chat history ID if present
        if (responseData.chat_history_id) {
          setChatHistoryId(responseData.chat_history_id);
          console.log('📚 Received chat history ID from non-streaming team response:', responseData.chat_history_id);
        }

        const rawHtml: string = await marked.parse(responseData.response);
        const tool_calls: any[] = [];
        responseData?.agent_responses?.forEach((agent_res: any) => {
          if (agent_res.metadata?.tool_calls) {
            tool_calls.push(...agent_res.metadata.tool_calls);
          }
        });

        setMessages((preVal) => {
          return [
            ...preVal,
            {
              sender: PlayGroundEnum.AGENT,
              agentData: {
                response: rawHtml,
                rawResponse: responseData.response,
                agent_responses: responseData.agent_responses,
                conversation_id: responseData.conversation_id,
                metadata: { tool_calls: tool_calls },
              },
            },
          ];
        });
      }
    } catch (err) {
      console.error("Streaming failed:", err);
    } finally {
      setBotTyping(false);
    }
  };

  const sendMessage = async () => {
    isCancelledStream.current = false;
    if (!userInput.trim()) return; // Hide Welcome messages

    // Check if userContext is available, if not, generate a guest user
    if (!userContext) {
      console.log('👤 No user context available, generating guest user');
      const guestUserId = crypto.randomUUID();
      const guestUserData = {
        id: guestUserId,
        name: 'Guest User',
        email: `${guestUserId}@dummy.zeaiq.com`,
        type: 'guest',
        timestamp: new Date().toISOString()
      };
      setUserContext(guestUserData);
      setUserId(guestUserId);

      // Notify parent window about guest user generation
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({
          type: 'GUEST_USER_GENERATED',
          message: 'Guest user generated for chat',
          data: guestUserData
        }, '*');
      }
    }

    setShowInitialMessage(false); // Hide Welcome messages
    setShowQuestions(false);
    const data: UserMessage = {
      input: userInput,
      conversation_id: "",
    };

    // Debug: Show current userContext state
    console.log('👤 Current userContext before creating payload:', userContext);
    console.log('👤 Current userId before creating payload:', userId);

    // Create the request payload for the API
    const requestPayload = {
      input: userInput,
      conversation_id: "",
      chat_history_id: chatHistoryId || undefined,
      metadata: {
        ...(pageContext && { page_context: pageContext }),
        ...(userContext && { user_context: userContext })
      }
    };

    console.log('📤 Sending message with payload:', requestPayload);
    console.log('📄 Page context available:', !!pageContext);
    console.log('📄 Page context value:', pageContext);
    console.log('👤 User context available:', !!userContext);
    console.log('👤 User context value:', userContext);
    userContext?.id && console.log('👤 User ID:', userContext.id);

    console.log('📄 Request payload JSON:', JSON.stringify(requestPayload, null, 2));

    // Debug: Show final payload structure
    console.log('🔍 Final request payload structure:', {
      hasInput: !!requestPayload.input,
      hasConversationId: !!requestPayload.conversation_id,
      hasChatHistoryId: !!requestPayload.chat_history_id,
      hasMetadata: !!requestPayload.metadata,
      hasPageContext: !!requestPayload.metadata?.page_context,
      hasUserContext: !!requestPayload.metadata?.user_context,
      userContextId: requestPayload.metadata?.user_context?.id
    });

    // Add user message
    setMessages((prev) => [
      ...prev,
      { sender: PlayGroundEnum.USER, userData: data },
    ]);
    setUserInput("");
    setBotTyping(true);
    try {
      if (agents?.team_metadata.streaming) {
        const response = await fetch(
          `${TEAMS}/${teamsId}/execute?stream=true`,
          {
            method: "POST",
            headers: {
              "x-api-key": `${apiKey}`,
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify(requestPayload),
            mode: "cors",
            credentials: "same-origin",
          }
        );

        if (!response.ok || !response.body) {
          throw new Error("Failed to stream");
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");

        // Add placeholder agent message
        setMessages((prev) => [...prev, { sender: PlayGroundEnum.AGENT, isMessageLike: null }]);

        let buffer = "";
        var content = "";
        const tool_calls: any[] = [];
        const citations: any[] = [];

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          if (isCancelledStream.current) break;

          buffer += decoder.decode(value, { stream: true });

          const lines = buffer.split("\n");
          for (const line of lines) {
            if (line.startsWith("data: ")) {
              const jsonPart = line.replace(/^data: /, "").trim();

              if (!jsonPart || jsonPart === "[DONE]") return;

              try {
                const parsed = JSON.parse(jsonPart);
                responseId.current = parsed.response_id
                if (!parsed.is_complete) {
                  content += parsed.response;
                  const sanitizedContent = await marked.parse(content);
                  setConversationId(parsed.conversation_id);

                  setMessages((preVal) => {
                    let lastMsg = preVal[preVal.length - 1];
                    lastMsg = {
                      ...lastMsg,
                      agentData: { response: sanitizedContent, rawResponse: content, conversation_id: parsed.conversation_id },

                    };
                    console.log(lastMsg);
                    return [...preVal.slice(0, preVal.length - 1), lastMsg];
                  });
                } else {
                  if (parsed?.metadata?.agent_responses) {
                    const agent_responses = parsed?.metadata.agent_responses;
                    agent_responses?.forEach((agent_res: any) => {
                      if (agent_res.metadata?.tool_calls) {
                        tool_calls.push(...agent_res.metadata.tool_calls);
                      }
                    });

                    if (parsed?.citation_data) {
                      citations.push(...parsed.citation_data);
                    }

                    setMessages((preVal) => {
                      let lastMsg = preVal[preVal.length - 1];
                      lastMsg = {
                        ...lastMsg,
                        agentData: {
                          response: lastMsg.agentData?.response || "",
                          rawResponse: lastMsg.agentData?.rawResponse || content,
                          conversation_id: lastMsg.agentData?.conversation_id,
                          agent_responses: agent_responses,
                          metadata: { tool_calls: tool_calls },
                          citations: citations,
                        },
                      };
                      // console.log(lastMsg)
                      return [...preVal.slice(0, preVal.length - 1), lastMsg];
                    });

                    // Extract chat history ID if present in the final chunk
                    if (parsed.chat_history_id) {
                      setChatHistoryId(parsed.chat_history_id);
                      console.log('📚 Received chat history ID from streaming team response:', parsed.chat_history_id);
                    }
                  }
                }
              } catch (e) {
                console.error("Parse error:", jsonPart, e);
              }
            }
          }

          // Keep partial buffer (in case a line is split across chunks)
          buffer = lines[lines.length - 1];
        }
      } else {
        const resData = await fetch(
          `${TEAMS}/${teamsId}/execute?stream=false`,
          {
            method: "POST",
            headers: {
              "x-api-key": `${apiKey}`,
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify(requestPayload),
            mode: "cors",
            credentials: "same-origin",
          }
        );

        if (!resData.ok) {
          throw new Error("Failed to response");
        }
        const responseData = await resData.json();
        responseId.current = responseData.response_id
        setConversationId(responseData.conversation_id);

        // Extract chat history ID if present
        if (responseData.chat_history_id) {
          setChatHistoryId(responseData.chat_history_id);
          console.log('📚 Received chat history ID from non-streaming team response:', responseData.chat_history_id);
        }

        const rawHtml: string = await marked.parse(responseData.response);
        const tool_calls: any[] = [];
        const citations: any[] = [];

        responseData?.agent_responses?.forEach((agent_res: any) => {
          if (agent_res.metadata?.tool_calls) {
            tool_calls.push(...agent_res.metadata.tool_calls);
          }
        });

        if (responseData?.citation_data) {
          citations.push(...responseData.citation_data);
        }

        setMessages((preVal) => {
          return [
            ...preVal,
            {
              sender: PlayGroundEnum.AGENT,
              agentData: {
                response: rawHtml,
                rawResponse: responseData.response,
                agent_responses: responseData.agent_responses,
                metadata: { tool_calls: tool_calls },
                citations: citations,
              },
            },
          ];
        });
      }
    } catch (err) {
      console.error("Streaming failed:", err);
    } finally {
      setBotTyping(false);
    }
  };

  const sendMessageShortcuts = async (shortcut: string, messageId: number) => {
    isCancelledStream.current = false;
    setShowQuestions(false);

    // Check if userContext is available, if not, generate a guest user
    if (!userContext) {
      console.log('👤 No user context available, generating guest user for shortcut');
      const guestUserId = crypto.randomUUID();
      const guestUserData = {
        id: guestUserId,
        name: 'Guest User',
        email: `${guestUserId}@dummy.zeaiq.com`,
        type: 'guest',
        timestamp: new Date().toISOString()
      };
      setUserContext(guestUserData);
      setUserId(guestUserId);

      // Notify parent window about guest user generation
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({
          type: 'GUEST_USER_GENERATED',
          message: 'Guest user generated for shortcut',
          data: guestUserData
        }, '*');
      }
    }

    const message = messages[messageId]?.agentData?.agent_responses
    const agents_id: string[] = []
    message?.map((item: any) => {
      if (item?.agent_id && item?.agent_id) {
        agents_id.push(item?.agent_id)
      }
    })

    const original_content = message?.reduce<any>((acc, item: any) => {
      if (item?.agent_name && item?.full_response) {
        acc[item?.agent_name] = item?.full_response || "";
      }
      return acc;
    }, {});

    if (original_content && Object.keys(original_content).length === 0) return;

    const data: UserMessage = {
      action: shortcut,
      original_content: original_content,
      conversation_id: conversationId ? conversationId : "",
      agents_id: agents_id,
    };

    // Debug: Show current userContext state
    console.log('👤 Current userContext before creating payload:', userContext);
    console.log('👤 Current userId before creating payload:', userId);

    // Create the request payload for the API
    const requestPayload = {
      action: shortcut,
      original_content: original_content,
      conversation_id: conversationId ? conversationId : "",
      agents_id: agents_id,
      chat_history_id: chatHistoryId || undefined,
      metadata: {
        ...(pageContext && { page_context: pageContext }),
        ...(userContext && { user_context: userContext })
      }
    };

    console.log('📤 Sending shortcut with payload:', requestPayload);
    console.log('📄 Page context available:', !!pageContext);
    console.log('📄 Page context value:', pageContext);
    console.log('👤 User context available:', !!userContext);
    console.log('👤 User context value:', userContext);
    userContext?.id && console.log('👤 User ID:', userContext.id);

    console.log('📄 Request payload JSON:', JSON.stringify(requestPayload, null, 2));

    // Debug: Show final payload structure
    console.log('🔍 Final request payload structure:', {
      hasAction: !!requestPayload.action,
      hasOriginalContent: !!requestPayload.original_content,
      hasConversationId: !!requestPayload.conversation_id,
      hasAgentsId: !!requestPayload.agents_id,
      hasChatHistoryId: !!requestPayload.chat_history_id,
      hasMetadata: !!requestPayload.metadata,
      hasPageContext: !!requestPayload.metadata?.page_context,
      hasUserContext: !!requestPayload.metadata?.user_context,
      userContextId: requestPayload.metadata?.user_context?.id
    });

    // Add user message
    setMessages((prev) => [
      ...prev,
      { sender: PlayGroundEnum.USER, userData: { ...data, input: `<i>${capitalizeFirstLetter(shortcut)}</i>` } },
    ]);
    setUserInput("");
    setBotTyping(true);
    try {
      if (!agents?.team_metadata.streaming) {
        const response = await fetch(
          `${TEAMS}/${teamsId}/get-post-response-shortcuts?stream=true`,
          {
            method: "POST",
            headers: {
              "x-api-key": `${apiKey}`,
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify(requestPayload),
            mode: "cors",
            credentials: "same-origin",
          }
        );

        if (!response.ok || !response.body) {
          throw new Error("Failed to stream");
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");

        // Add placeholder agent message
        setMessages((prev) => [...prev, { sender: PlayGroundEnum.AGENT, isMessageLike: null }]);

        let buffer = "";
        var content = "";
        const tool_calls: any[] = [];
        const citations: any[] = [];
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          if (isCancelledStream.current) break;

          buffer += decoder.decode(value, { stream: true });

          const lines = buffer.split("\n");
          for (const line of lines) {
            if (line.startsWith("data: ")) {
              const jsonPart = line.replace(/^data: /, "").trim();

              if (!jsonPart || jsonPart === "[DONE]") return;

              try {
                const parsed = JSON.parse(jsonPart);
                if (!parsed.is_complete) {
                  content += parsed.response;
                  const sanitizedContent = await marked.parse(content);
                  setConversationId(parsed.conversation_id);

                  setMessages((preVal) => {
                    let lastMsg = preVal[preVal.length - 1];
                    lastMsg = {
                      ...lastMsg,
                      agentData: { response: sanitizedContent, conversation_id: parsed.conversation_id },
                    };
                    return [...preVal.slice(0, preVal.length - 1), lastMsg];
                  });
                } else {
                  // Handle chart data if present
                  if (parsed.is_chart && parsed.response) {
                    try {
                      const chartData = JSON.parse(parsed.response);
                      setMessages((preVal) => {
                        let lastMsg = preVal[preVal.length - 1];
                        lastMsg = {
                          ...lastMsg,
                          agentData: {
                            ...lastMsg.agentData,
                            chartData: chartData,
                            response: "",
                            citations: citations,
                          },
                        };
                        return [...preVal.slice(0, preVal.length - 1), lastMsg];
                      });
                    } catch (chartError) {
                      console.error("Failed to parse chart data:", chartError);
                    }
                  }
                  if (parsed?.metadata?.agent_responses) {
                    const agent_responses = parsed?.metadata.agent_responses;
                    agent_responses?.forEach((agent_res: any) => {
                      if (agent_res.metadata?.tool_calls) {
                        tool_calls.push(...agent_res.metadata.tool_calls);
                      }
                    });
                    setMessages((preVal) => {
                      let lastMsg = preVal[preVal.length - 1];
                      lastMsg = {
                        ...lastMsg,
                        agentData: {
                          ...lastMsg.agentData,
                          response: lastMsg.agentData?.response || "",
                          conversation_id: lastMsg.agentData?.conversation_id || "",
                          agent_responses: agent_responses,
                          metadata: { tool_calls: tool_calls },
                        },
                      };
                      return [...preVal.slice(0, preVal.length - 1), lastMsg];
                    });
                  }

                  // Extract chat history ID if present in the final chunk
                  if (parsed.chat_history_id) {
                    setChatHistoryId(parsed.chat_history_id);
                    console.log('📚 Received chat history ID from shortcut streaming team response:', parsed.chat_history_id);
                  }
                }
              } catch (e) {
                console.error("Parse error:", jsonPart, e);
              }
            }
          }

          // Keep partial buffer (in case a line is split across chunks)
          buffer = lines[lines.length - 1];
        }
      } else {
        const resData = await fetch(
          `${TEAMS}/${teamsId}/get-post-response-shortcuts?stream=false`,
          {
            method: "POST",
            headers: {
              "x-api-key": `${apiKey}`,
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify(requestPayload),
            mode: "cors",
            credentials: "same-origin",
          }
        );

        if (!resData.ok) {
          throw new Error("Failed to response");
        }
        const responseData = await resData.json();
        setConversationId(responseData.conversation_id);

        // Extract chat history ID if present
        if (responseData.chat_history_id) {
          setChatHistoryId(responseData.chat_history_id);
          console.log('📚 Received chat history ID from non-streaming shortcut team response:', responseData.chat_history_id);
        }

        const rawHtml: string = await marked.parse(responseData.response);
        const tool_calls: any[] = [];
        responseData?.agent_responses?.forEach((agent_res: any) => {
          if (agent_res.metadata?.tool_calls) {
            tool_calls.push(...agent_res.metadata.tool_calls);
          }
        });

        // Handle chart data if present
        if (responseData.is_chart && responseData.response) {
          try {
            const chartData = JSON.parse(responseData.response);
            setMessages((preVal) => [
              ...preVal,
              {
                sender: PlayGroundEnum.AGENT,
                agentData: {
                  response: "",
                  chartData: chartData,
                  agent_responses: responseData.agent_responses,
                  conversation_id: responseData.conversation_id,
                  metadata: { tool_calls: tool_calls },
                },
              },
            ]);
          } catch (chartError) {
            console.error("Failed to parse chart data:", chartError);
          }
        } else {
          setMessages((preVal) => [
            ...preVal,
            {
              sender: PlayGroundEnum.AGENT,
              agentData: {
                response: rawHtml,
                agent_responses: responseData.agent_responses,
                conversation_id: responseData.conversation_id,
                metadata: { tool_calls: tool_calls },
              },
            },
          ]);
        }
      }
    } catch (err) {
      console.error("Streaming failed:", err);
    } finally {
      setBotTyping(false);
    }
  };


  const clearChat = () => {

    isCancelledStream.current = true;

    setShowHistory(false);

    // Clear all messages
    setMessages([]);

    // Clear user input
    setUserInput("");

    // Stop bot typing
    setBotTyping(false);

    // Show initial message and questions
    setShowInitialMessage(true);
    setShowQuestions(true);

    // Clear conversation ID and chat history ID to start fresh
    setConversationId("");
    setChatHistoryId("");

    // Generate new unique ID for new chat
    const newUniqueId = uuidv4();

    console.log('🆕 New chat started with ID:', newUniqueId);
  };

  const handleClickDots = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleViewRecentChats = async () => {
    setShowHistory(true);
    handleClose();

    // Fetch initial chat history data
    await fetchChatHistories(1);
  };

  const handleStartNewChat = () => {
    setShowHistory(false);
    clearChat();
    handleClose();
  };
  const handleEndChat = () => {
    clearChat();
    handleClose();
  };

  const handleBackToChat = () => {
    setShowHistory(false);
    setChatHistories([]);
    setCurrentPage(1);
  };

  const handlePageChange = async (page: number) => {
    setCurrentPage(page);
    await fetchChatHistories(page);
  };

  const fetchChatHistories = async (page: number) => {
    try {
      const response = await fetch(`${CHAT_HISTORY}?user_id=${userId || guestUserId}&page=${page}&page_size=${pageSize}&agent_id=${teamsId}`, {
        method: "GET",
        headers: {
          "x-api-key": `${apiKey}`,
          "Content-Type": "application/json",
        },
        mode: "cors",
        credentials: "same-origin",
      });

      if (response.ok) {
        const data = await response.json();
        setChatHistories(data.items || []); // Changed from data.chat_history
        setTotalPages(data.pagination?.total_pages || 1); // Changed from data.total_pages
      } else {
        console.error('Failed to fetch chat histories');
        setChatHistories([]);
      }
    } catch (error) {
      console.error('Error fetching chat histories:', error);
      setChatHistories([]);
    }
  };


  const handleChatHistorySelect = async (chatData: any) => {
    console.log(' Chat data received:', chatData); // Debug log

    try {
      dispatch(StartLoading());

      // The chatData might be the chat history item directly, or it might be wrapped differently
      // Let's check the structure and extract the ID
      let chatId = chatData?.id || chatData?.chat_history_id || chatData;

      if (!chatId) {
        console.error('❌ Chat ID is undefined:', chatData);
        return;
      }

      console.log('🔍 Using chat ID:', chatId);

      const response = await fetch(
        `${CHAT_HISTORY_DETAIL}/${chatId}/detail`,
        {
          method: "GET",
          headers: {
            "x-api-key": `${apiKey}`,
            "Content-Type": "application/json",
          },
          mode: "cors",
          credentials: "same-origin",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch chat history details");
      }

      const chatDetails = await response.json();

      // Set the conversation ID from the loaded chat
      setConversationId(chatDetails.conversation_id);

      // Convert the chat history format to the Message format used in the component
      const convertedMessages: Message[] = [];

      for (const msg of chatDetails.messages) {
        // User message
        convertedMessages.push({
          sender: PlayGroundEnum.USER,
          userData: {
            input: msg.user_message,
            conversation_id: msg.agent_response.conversation_id,
          },
        });

        // Agent message - Parse the response through markdown to preserve formatting
        const parsedResponse = await marked.parse(msg.agent_response.response);
        convertedMessages.push({
          sender: PlayGroundEnum.AGENT,
          agentData: {
            response: parsedResponse, // Use parsed HTML instead of plain text
            rawResponse: msg.agent_response.response, // Store plain text for copy button
            metadata: {
              tool_calls: msg.agent_response.metadata.tool_calls || [],
              extra_data: msg.agent_response.metadata.extra_data || {},
            },
          },
        });
      }

      // Set the messages
      setMessages(convertedMessages);

      // Hide the initial message and questions since we now have conversation history
      setShowInitialMessage(false);
      setShowQuestions(false);

      // Hide the history view and show the chat
      setShowHistory(false);

      // Set the chat history ID
      setChatHistoryId(chatId);
      // setChatHistoryId(chatHistoryId);


      console.log('📚 Loaded chat history details:', {
        conversationId: chatDetails.conversation_id,
        messageCount: chatDetails.message_count,
        messages: convertedMessages.length
      });

    } catch (error) {
      console.error("Error loading chat history details:", error);
    } finally {
      dispatch(StopLoading());
    }
  };

  const callLastChatHistory = (historyId: string) => {
    console.log('🔍 Calling last chat history:', historyId);

    // Guard against missing user context
    if (agents?.team_metadata?.user_context_awareness) {
      if (!userContext?.id) {
        console.log('⚠️ Cannot call last chat history: no user context available');
        return;
      }
    }
    handleChatHistorySelect(historyId);
  };

  // Load chat history ID from localStorage on component mount
  useEffect(() => {
    if (teamsId && userContext?.id) {
      const userId = userContext.id; // Extract to local variable
      const storageKey = `zeaiq_chat_history_${teamsId}_${userId}`;
      const storedChatHistoryId = localStorage.getItem(storageKey);
      if (storedChatHistoryId) {
        setChatHistoryId(storedChatHistoryId);
        console.log('📚 Loaded chat history ID from localStorage:', storedChatHistoryId);
      }
    }
  }, [teamsId, userContext?.id]);

  // Save chat history ID to localStorage whenever it changes
  useEffect(() => {
    if (teamsId && userContext?.id && chatHistoryId) {
      const userId = userContext.id;
      const storageKey = `zeaiq_chat_history_${teamsId}_${userId}`;
      localStorage.setItem(storageKey, chatHistoryId);
      console.log(' Saved chat history ID to localStorage:', chatHistoryId);
    }
  }, [teamsId, userContext?.id, chatHistoryId]);

  // call last chat history on reload
  useEffect(() => {
    if (agents?.team_metadata?.user_context_awareness && chatHistoryId) {
      callLastChatHistory(chatHistoryId);
    }
  }, [chatHistoryId, agents?.team_metadata?.user_context_awareness]);



  // Smooth Scrolling to Bottom on New Message

  return (
    <Box
      sx={{ width: "100vw", height: "100vh", p: 0, m: 0, background: "#fff" }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100vw",
          marginLeft: 0,
          marginRight: 0,
          borderColor: "rgba(24, 24, 27, .1)",
          borderRadius: "30px",
          background: agentTheme.backgroundColor,
          overflow: "hidden",
          boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Header */}
        <Box
          position="sticky"
          sx={{
            background: agentTheme.backgroundColor,
            borderBottom: "1px solid #f9f7f7",
            px: 4,
            py: 1.5,
            display: showHistory ? "none" : "flex",
            justifyContent: "space-between",
            alignItems: "center",
            boxShadow: "0 15px 30px 0 rgba(256, 256, 256, 1)",
            zIndex: 1,
            top: 0,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
              }}
            >
              <img
                src={LogoIcon}
                alt="Company Logo"
                style={{ width: 30, height: "auto" }}
              />
            </Box>
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, textTransform: "capitalize", color: agentTheme.titleColor }}
            >
              {agents?.name || "Chat"}
            </Typography>
          </Box>

          <Box>
            <IconButton
              id="demo-positioned-button"
              aria-controls={open ? "demo-positioned-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClickDots}
            >
              <MoreHorizIcon />
            </IconButton>
            <Menu
              id="demo-positioned-menu"
              aria-labelledby="demo-positioned-button"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              PaperProps={{
                elevation: 0,
                sx: {
                  boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
                  borderRadius: 2,
                },
              }}
            >
              <MenuItem onClick={handleStartNewChat}>
                <ListItemIcon>
                  <NewChatIcon />
                </ListItemIcon>
                <ListItemText>Start a new chat</ListItemText>
              </MenuItem>

              <MenuItem onClick={handleEndChat}>
                <ListItemIcon>
                  <EndChatIcon />
                </ListItemIcon>
                <ListItemText>End chat</ListItemText>
              </MenuItem>

              {agents?.team_metadata?.user_context_awareness && (
                <MenuItem onClick={handleViewRecentChats}>
                  <ListItemIcon>
                    <RecentChatIcon />
                  </ListItemIcon>
                  <ListItemText>View recent chats</ListItemText>
                </MenuItem>
              )}
            </Menu>
          </Box>
        </Box>

        {/* Chat Messages */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            height: "calc(100% - 130px)",
            alignItems: showHistory ? "flex-start" : "center",
            p: 0,
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              maxHeight: "100%",
              overflow: "auto",
              p: showHistory ? 0 : 4,
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0, 0, 0, 0.2)",
                borderRadius: "3px",
              },
              "&::-webkit-scrollbar-thumb:hover": {},
              "&::-webkit-scrollbar-track": {},
            }}
          >
            {/* Main Text */}
            {showHistory ? (
              // History View using RecentChatsByUser component with same props as IFrameAgent
              <RecentChatsByUser
                historyData={{
                  items: chatHistories,
                  pagination: {
                    total: totalPages,
                    page: currentPage,
                    perPage: 10,
                  },
                }}
                onPageChange={handlePageChange}
                onBack={handleBackToChat}
                clearChat={clearChat}
                onChatSelect={handleChatHistorySelect}
              />
            ) : (
              // Chat View
              <>
                {/* Main Text */}
                {showInitialMessage && (
                  <PlayGroundInitialMessage
                    message={intialMessage}
                    incomingTextColor={agentTheme.incomingChatTextColor}
                  />
                )}
              </>
            )}

            {messages.map((msg, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  mb: 3,
                }}
              >
                <Box sx={{ width: "100%" }}>
                  {/* Tool chips visible for all messages */}
                  {msg?.agentData?.metadata?.tool_calls &&
                    msg?.agentData?.metadata?.tool_calls?.length > 0 && (
                      <AgentPlayGroundTools
                        tools={msg?.agentData.metadata.tool_calls || []}
                      />
                    )}

                  {/* Bot Message */}
                  {msg.sender === PlayGroundEnum.AGENT ? (
                    <Box sx={{ display: "flex" }}>
                      <Box
                        sx={{
                          display: "flex",
                          mr: 2,
                          height: "24px",
                        }}
                      >
                        <img
                          src={LogoIcon}
                          alt="Company Logo"
                          style={{ width: 24, height: "auto" }}
                        />
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          width: "100%",
                        }}
                      >

                        {/* Main Text */}
                        <Typography
                          key={index}
                          variant="body2"
                          component="div"
                          sx={{
                            color: agentTheme.incomingChatTextColor,
                            whiteSpace: "normal",
                            "& table": {
                              borderCollapse: "collapse",
                              width: "100%",
                              margin: "8px 0",
                            },
                            "& th, & td": {
                              border: "1px solid #bdbdbd",
                              padding: "6px 10px",
                            },
                            "& th": {
                              background: "#f5f5f5",
                              fontWeight: 600,
                            },
                          }}
                          dangerouslySetInnerHTML={{
                            __html: msg?.agentData?.response || "...",
                          }}
                        />
                        {/* propmts and short cuts */}
                        <AgentPrompts
                          agentShortuts={agentShortcuts}
                          messageId={index}
                          sendMessageShortcuts={sendMessageShortcuts}
                          incomingTextColor={incomingTextColor}
                          messages={messages}
                          setMessages={setMessages}
                          agentId={teamsId}
                          responseId={responseId.current}
                          conversationId={conversationId}
                          apiKey={apiKey}
                          useApiKey={true}
                        />

                        {/* References */}
                        {msg.agentData?.metadata?.extra_data && (
                          <AgentPlaygroundReferences
                            data={msg?.agentData?.citations}
                            setShowCitations={setShowCitations}
                            incomingTextColor={incomingTextColor}
                          />
                        )}
                      </Box>
                    </Box>
                  ) : (
                    // User Message
                    <Box sx={{ display: "flex" }}>
                      <Avatar
                        variant="rounded"
                        sx={{
                          width: 24,
                          height: 24,
                          borderRadius: "50%",
                          bgcolor: variables.blackColor,
                          mr: 2,
                          p: "3px",
                        }}
                      >
                        <LineMdAccount />
                      </Avatar>
                      <Typography
                        variant="body2"
                        sx={{ lineHeight: "24px", whiteSpace: "pre-wrap", color: agentTheme.outgoingChatTextColor }}
                        dangerouslySetInnerHTML={{
                          __html: msg?.userData?.input || "",
                        }}
                      />
                    </Box>
                  )}
                </Box>
                <div ref={endOfMessagesRef} />
              </Box>
            ))}
            {botTyping && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  mb: 3,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    mr: 2,
                    height: "24px",
                  }}
                >
                  <img
                    src={LogoIcon}
                    alt="Company Logo"
                    style={{ width: 24, height: "auto" }}
                  />
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", height: 24 }}>
                  <TypingIndicator />
                </Box>
              </Box>
            )}
          </Box>
        </Box>

        {/* Input Field - Only show when not in history view */}
        {!showHistory && (
          <Box
            sx={{
              display: "flex",
              gap: 1,
              alignItems: "flex-start",
              p: 2,
              bgcolor: "rgba(255, 255, 255, 0.2)",
              width: "100%",
              position: "sticky",
              bottom: 0,
              borderTop: "1px solid rgba(24, 24, 27, .1)",
              flexDirection: "column",
            }}
          >
            {/* default questions */}
            {showQuestions && teamsId && (
              <AgentQuestions
                sendMessageQuestions={sendMessageQuestions}
                teamsId={teamsId}
              />
            )}
            <Box
              sx={{
                border: "1px solid rgba(24, 24, 27, .1)",
                boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
                borderRadius: "20px",
                width: "100%",
                position: "relative",
                padding: "12px 16px",
                background: "#fff",
              }}
            >
              <TextField
                fullWidth
                multiline
                variant="outlined"
                size="small"
                maxRows={4}
                placeholder="Ask anything..."
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    sendMessage();
                  }
                }}
                inputRef={inputRef}
                disabled={botTyping}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    fontSize: "14px",
                    maxHeight: "120px",
                    overflowY: "auto",
                    pr: "40px",
                    "&::-webkit-scrollbar": {
                      width: "6px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "rgba(0, 0, 0, 0.2)",
                      borderRadius: "3px",
                    },
                    "& fieldset": {
                      border: "none",
                    },
                    "&:hover fieldset": {
                      border: "none",
                    },
                    "&.Mui-focused fieldset": {
                      border: "none",
                    },
                  },
                }}
              />
              <Button
                onClick={sendMessage}
                disabled={botTyping || !userInput}
                sx={{
                  width: 40,
                  height: 40,
                  background: variables.primaryColor,
                  color: variables.whiteColor,
                  minWidth: 0,
                  borderRadius: "50%",
                  position: "absolute",
                  bottom: "10px",
                  right: "10px",
                  "&.Mui-disabled": {
                    color: variables.whiteColor,
                    opacity: 0.5,
                  },
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M10 14L21 3m0 0l-6.5 18a.55.55 0 0 1-1 0L10 14l-7-3.5a.55.55 0 0 1 0-1z"
                  />
                </svg>
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default IFrameMultiAgent;
